export default (kilometers: number) => kilometers * 0.621_371
